// 언어별 공개 URL 변환 유틸 (ko: 접두어 없음, en/ja/zh/th: /{lang})
const EXTERNAL = /^(https?:)?\/\//i;
const LOCALE_RE = /^\/(ko|en|ja|zh|th)(?=\/|$)/;

export function isExternal(href = "") {
  return EXTERNAL.test(href) || href.startsWith("tel:") || href.startsWith("mailto:");
}
export function norm(href = "/") {
  return href.startsWith("/") ? href : `/${href}`;
}
export function stripLeadingLocale(path = "/") {
  return (path || "/").replace(LOCALE_RE, "") || "/";
}

// 외국어 주소 /{lang}/X 는 rewrite 로 /main/X 를 보여 준다 (makeNextConfig).
// 그래서 /main/X 로 저장된 링크(관리자 메뉴의 /main/myTickets 등)에 언어만 붙이면
// /en/main/X → /main/main/X 가 되어 404 — 외국어일 때는 /main 을 뗀다.
// 한국어는 /main/X 가 그대로 열리므로 건드리지 않는다.
const MAIN_PREFIX_RE = /^\/main(?=[/?#]|$)/;

/** 언어별 공개 URL로 변환 (ko: 접두어 없음, en/ja/zh: /{lang}) */
export function withLocaleHref(href = "/", locale = "ko") {
  if (isExternal(href)) return href;
  let p = norm(href);
  p = stripLeadingLocale(p);
  if (locale && locale !== "ko") {
    p = p.replace(MAIN_PREFIX_RE, "") || "/";
    return `/${locale}${p === "/" ? "" : p}`;
  }
  return p || "/";
}
